import React from 'react';
import { composer } from '../../../../component-decorators/composer';
import { Text } from '@wix/design-system';
import { useSolution } from '../contexts/solution';
export const AppDeveloper = composer()
    .withTranslation()
    .compose(({ t }) => {
    const solution = useSolution();
    const { company } = solution;
    return (React.createElement(Text, { secondary: true, size: "tiny", weight: "thin" }, t('solutionBox.solutionDetails.companyName', {
        company: company?.name,
    })));
});
//# sourceMappingURL=AppDeveloper.js.map